import { cr } from "fire-wind-water";
import URL from "@/assets/conf/setting.json";
import SETTURL from "../assets/conf/setting.json";
import { resetURL } from "../../stempcore/src/sbase";
import LangManager from "@/model/lang";
window.$sk.setApiUrl(URL.template.api.gateway.general);
window.$sk.setUploadUrl(URL.sbaseUrl);
resetURL(SETTURL);
export const api = {
  cacheParams: {
    _cache_with_cached: 1,
    _cache_refresh: 0,
    _cache_timeout: 300,
  },
};
export default {
  getForNewForm(params) {
    return window.$sk.$skxhrp(
      "member/form/GetForNewForm",
      cr.extend({ lang: LangManager.current }, params)
    );
  },
  // 获取租户启用的语言列表（与 memberfront 项目的 admin.tenant.setting.lang.query 一致）
  getTenantLangs(params) {
    return window.$sk.$skxhrp("admin/tenant/setting/lang/query", params);
  },
  login(params) {
    return window.$sk.$skxhrp("member/login", params);
  },
  getJsonParams(params) {
    return window.$sk
      .$skxhrp("api/common/jsonParams/get", cr.extend(params, api.cacheParams))
      .then((data) => {
        console.log("[mtv-i18n] getJsonParams response received:", data);
        // 拦截 i18n 配置：把后端合并进来的 langs 同步给 LangManager
        // 目的：减少前端单独调 admin/tenant/setting/lang/query 的请求次数
        try {
          if (
            data &&
            (data.result === 0 || data.result === "0") &&
            data.content &&
            data.content.i18n
          ) {
            const i18n = data.content.i18n;
            console.log("[mtv-i18n] i18n field present:", i18n);
            const langs = ["zh_CN"];
            if (i18n.items && i18n.items.length > 0) {
              i18n.items.forEach((item) => {
                console.log("[mtv-i18n] processing item:", item);
                if (item.isEnable === "1" || item.isEnable === 1) {
                  // 保持原始格式 en_US（下划线），不转换
                  const lang = item.name || "";
                  console.log("[mtv-i18n] parsed lang:", lang);
                  if (lang && langs.indexOf(lang) < 0) langs.push(lang);
                }
              });
            }
            console.log("[mtv-i18n] final langs to setAvailable:", langs);
            LangManager.setAvailable(langs);
            window.$sk = window.$sk || {};
            window.$sk.langs = langs;
            window.$sk.i18nEnabled = !!i18n.enabled;
            console.log(
              "[mtv-i18n] after setAvailable, LangManager.available =",
              LangManager.available
            );
          } else {
            console.log(
              "[mtv-i18n] response has no i18n field or result mismatch. data.result =",
              data && data.result
            );
          }
        } catch (e) {
          console.error("[mtv-i18n] error in getJsonParams interceptor:", e);
        }
        return data;
      });
  },
  getUnique(params) {
    return window.$sk.$skxhrp("member/form/getUnique", params);
  },
  memberLogin(params) {
    return window.$sk.$skxhrp("member/login", params);
  },
  getToken(params) {
    return window.$sk.$skxhrp("member/GetToken", params);
  },
  sendCheckCode(params) {
    return window.$sk.$skxhrp("member/sendCheckCode", params);
  },
  getFormNewRegister(params) {
    return window.$sk.$skxhrp(
      "api/member/form/get",
      cr.extend(params, api.cacheParams)
    );
  },
  getForm(params) {
    return window.$sk.$skxhrp(
      "member/form/GetForNewForm",
      cr.extend({ lang: LangManager.current }, params, api.cacheParams)
    );
  },
  register(params) {
    return window.$sk.$skxhrp("member/register", params);
  },
  getParamTree(params) {
    return window.$sk.$skxhrp("dic/params/getTree", params);
  },
  orderUnique(params) {
    return window.$sk.$skxhrp("member/schema/orderUnique", params);
  },
  checkUnique(params) {
    return window.$sk.$skxhr("member/checkUnique", params);
  },
  checkCode(params) {
    return window.$sk.$skxhrp("member/checkCode", params);
  },
  forgetPwd(params) {
    return window.$sk.$skxhrp("member/forgetPwd", params);
  },
  lookUp(params) {
    return window.$sk.$skxhrp("member/LookUp", params);
  },
  update(params) {
    return window.$sk.$skxhrp("api/member/contacts/info/update", params);
  },
  record(params) {
    return window.$sk.$skxhrp("member/interaction/record", params);
  },
  getTemplateConfig(params) {
    return window.$sk.$skxhr("template/platform/instance/getConfig", params);
  },
  getMyInfo(params) {
    return window.$sk.$skxhrp("api/member/contacts/info/get", params);
  },
  logout(params) {
    return window.$sk.$skxhrp("member/member/associate/Logout", params);
  },
  getDomain(tenantId) {
    return window.$sk.$skxhrp("api/domain/GetDomain", { tenantId: tenantId });
  },
  // 检查推广链接状态
  checkTrackStatus: (info) => {
    return window.$sk.$skxhrp("api/channel/track/info", info);
  },
};
